import type { OperationType } from '../api/types';

/**
 * Which reference fields each operation type carries (SPEC §1 / DB CHECKs):
 * store — required / optional attribution / forbidden; sklad and category —
 * required when true. Shared by the quick-entry forms and the edit modal.
 */
export const TYPE_FIELDS: Record<
  OperationType,
  { store: 'required' | 'optional' | 'none'; sklad: boolean; category: boolean }
> = {
  PURCHASE: { store: 'optional', sklad: true, category: false },
  ISSUE: { store: 'required', sklad: false, category: false },
  STORE_PAYMENT: { store: 'required', sklad: false, category: false },
  SKLAD_PAYMENT: { store: 'none', sklad: true, category: false },
  EXPENSE: { store: 'optional', sklad: false, category: true },
};
